import adminService from "@/services/admin.service";

export default {
    data() {
    return {
      /* data */
    };
    },
  created: function () {},
    methods: {
        com_UpdateTokenAndTime(token) {
          var current = new Date();
          localStorage.removeItem("jwt_token");
          localStorage.removeItem("tkutim");
          localStorage.setItem("jwt_token", token);
          localStorage.setItem("tkutim", current.getTime());
      },

      com_setLoginData(param) {
        let rootObject = this;
        if (param.jwt_token) {
                localStorage.setItem("jwt_token", param.jwt_token);
        rootObject.$store.dispatch("changLoginStatus", true);
        rootObject.$store.dispatch("setUser", param.userdata.username);
                rootObject.com_CheckVisitActivityAndTokenStatus();
                if (param.redirect_url) {
                    rootObject.$router.push(param.redirect_url);
                }
        } else {
            localStorage.removeItem("jwt_token");
        localStorage.removeItem("user");
        localStorage.removeItem("upgradeModalDismissed");
        rootObject.$store.dispatch("setUser", null);
        rootObject.$store.dispatch("changLoginStatus", false);
        rootObject.$store.dispatch("setWsServerLoadConnection", {});
        rootObject.$store.dispatch("auth/logout");
            rootObject.com_CheckVisitActivityAndTokenStatus(false);
            if (param.redirect_url) {
                rootObject.$router.push(param.redirect_url);
            }
        }
    },
    com_displayDateFormat(date, isObject = true) {
        var newDate = new Date(date);
        var resultArr = [];
      var convertedDate =
        newDate.getFullYear() +
        "-" +
        ("0" + (newDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + newDate.getDate()).slice(-2);

        var convertedHour = newDate.getHours();
        if (isObject) {
            resultArr = { date: convertedDate, hour: convertedHour };
        } else {
        resultArr =
          convertedDate +
          " " +
          newDate.getHours() +
          ":" +
          newDate.getMinutes() +
          ":" +
          newDate.getSeconds();
        }
        return resultArr;
    },
    com_setPanelData(param) {
      this.$store.dispatch("setPanelData", param.panel_settings);
        let loginparam = {
        jwt_token: localStorage.getItem("jwt_token"),
        };
        this.com_setLoginData(loginparam);
    },
    com_CheckVisitActivityAndTokenStatus(startInterval = true) {
      var rootObject = this;
      var intervalObj = null;
      var maxIdleTime = process.env.VUE_APP_MAXIDLETIME;
      var intervalTime = process.env.VUE_APP_CHECKACTIVITYINTERVALTIME;
      var tokenRefreshTime = process.env.VUE_APP_TOKENREFRESHTIME;

      if (startInterval) {
          intervalObj = setInterval(function () {
          var lastActivityTime = localStorage.getItem("lastActivityTime");
          var lasttokenUpdateTime = localStorage.getItem("tkutim");
              var current = new Date();
          var totalIdleTime =
            parseInt(lastActivityTime) + parseInt(maxIdleTime);
              if (totalIdleTime < current.getTime()) {
                  intervalObj = localStorage.getItem("visitActvityProcess");
                  clearInterval(intervalObj);
                  let loginparam = {
              jwt_token: "",
              redirect_url: "login",
                  };
                  rootObject.com_setLoginData(loginparam);
              } else {
            var nextTokenRefreshTime =
              parseInt(lasttokenUpdateTime) + parseInt(tokenRefreshTime);
                  if (current.getTime() >= nextTokenRefreshTime) {
                      rootObject.com_RefreshToken();
                  }
              }
          }, intervalTime);
        localStorage.setItem("visitActvityProcess", intervalObj);
      } else {
          intervalObj = localStorage.getItem("visitActvityProcess");
          if (intervalObj) {
              clearInterval(intervalObj);
              localStorage.removeItem("visitActvityProcess");
          }
      }
  },
  com_SetLastActivityTime() {
    var current = new Date();
      localStorage.setItem("lastActivityTime", current.getTime());
},
com_RefreshToken() {
  var rootObject = this;
      adminService
        .getRefreshToken()
        .then(function (response) {
      rootObject.com_UpdateTokenAndTime(response.token);
  })
      .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response) {
            alertmessage += " " + error.response[prop];
          }
          console.log(alertmessage);
          rootObject.com_errorHandel(error);
      });
},
com_errorHandel(error) {
  if (error.response.status == 401) {
      let loginparam = {
          jwt_token: "",
          redirect_url: "login",
      };
      this.com_setLoginData(loginparam);
  }
},
com_removeHostedPinPrefix(actualPin, prefix, panel_type) {
      if (panel_type == "hosted") {
        var newPin = actualPin.replace(prefix, "");
        var hostedPin = newPin;
        if (newPin.charAt(0) === "-") {
            hostedPin = newPin.substring(1);
        }
        return hostedPin;
    } else {
        return actualPin;
    }
},
    com_currentDateTime(format = "", time = "") {
    const monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    var current = new Date();

      if (format == "dmy") {
        var date =
          ("0" + current.getDate()).slice(-2) +
          " " +
          monthShortNames[current.getMonth()] +
          ", " +
          current.getFullYear();
    } else {
        date =
          current.getFullYear() +
          "-" +
          ("0" + (current.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + current.getDate()).slice(-2);
    }

      if (time == "" || time == "yes") {
        time =
          ("0" + current.getHours()).slice(-2) +
          ":" +
          ("0" + current.getMinutes()).slice(-2) +
          ":" +
          ("0" + current.getSeconds()).slice(-2);
    } else {
        time = "";
    }

      var dateTime = date + " " + time;
    return dateTime;
},
    com_modifyDateTime(no_of_days = 0, date = "") {
    if (date != "") {
        var newDate = new Date(date);
    } else {
         newDate = new Date();
    }

    if (parseInt(no_of_days) != 0) {
        newDate.setDate(newDate.getDate() + parseInt(no_of_days));
    }

      var modifiedDate =
        newDate.getFullYear() +
        "-" +
        ("0" + (newDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + newDate.getDate()).slice(-2) +
        " " +
        ("0" + newDate.getHours()).slice(-2) +
        ":" +
        ("0" + newDate.getMinutes()).slice(-2) +
        ":" +
        ("0" + newDate.getSeconds()).slice(-2);
    return modifiedDate;
},
com_pageNotFound() {
      this.$router.push("pagenotfound");
},
    },
};
